export function getValueFromModel(model, path) {
    if (!path || path.trim() === '') {
        return null;
    }
    const keys = path.split('.');
    let current = model;
    for (const key of keys) {
        if (typeof current === 'object' && current !== null && key in current) {
            current = current[key];
        } else {
            return null;
        }
    }
    return current;
}

const MODEL_BINDING_PATTERN = /@\{([^}]+)\}/g;
const FULL_MODEL_BINDING_PATTERN = /^@\{([^}]+)\}$/;

function stringifyBindingValue(value) {
    if (value === null || value === undefined) {
        return "";
    }

    return String(value);
}

export function resolveModelBindingValue(value, globalModel) {
    if (typeof value !== "string") {
        return value;
    }

    const fullBindingMatch = value.trim().match(FULL_MODEL_BINDING_PATTERN);

    if (fullBindingMatch) {
        return getValueFromModel(globalModel, fullBindingMatch[1].trim());
    }

    return value.replace(MODEL_BINDING_PATTERN, (_match, path) =>
        stringifyBindingValue(getValueFromModel(globalModel, path.trim()))
    );
}

export function resolveModelBindings(value, globalModel) {
    if (Array.isArray(value)) {
        return value.map((item) => resolveModelBindings(item, globalModel));
    }

    if (value && typeof value === "object") {
        return Object.fromEntries(
            Object.entries(value).map(([key, nestedValue]) => [
                key,
                resolveModelBindings(nestedValue, globalModel),
            ])
        );
    }

    return resolveModelBindingValue(value, globalModel);
}

export function parseViewModel(viewModel, globalModel) {
    const processed = {};
    for (const [key, value] of Object.entries(viewModel)) {
        processed[key] = resolveModelBindingValue(value, globalModel);
    }
    return processed;
}
